export const FETCH_DETAILED_USER_SUBMIT = 'FETCH_DETAILED_USER_SUBMIT';
export const FETCH_DETAILED_USER_SUCCESS = 'FETCH_DETAILED_USER_SUCCESS';

export const UPDATE_USER_SUBMIT = 'UPDATE_USER_SUBMIT';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';

export const FETCH_USER_ORG_MEMBERSHIPS_SUBMIT = 'FETCH_USER_ORG_MEMBERSHIPS_SUBMIT';
export const FETCH_USER_ORG_MEMBERSHIPS_SUCCESS = 'FETCH_USER_ORG_MEMBERSHIPS_SUCCESS';
